import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpService} from '../services/http.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
})
export class BlogComponent implements OnInit, OnDestroy {

    public blogList = [];
    public blogQuantity = 0;
    public blogLoaded = false;
    public AppConfig = AppConfig;
    public params = {};
    public currentPage = 1;
    public sub: any;
    public navSub: any;
    public link_books: any;
    public lastComments: any;


    constructor(public router: Router, private activatedRoute: ActivatedRoute, public http: HttpService,
    public cd: ChangeDetectorRef) {
        this.navSub = router.events.subscribe((val) => {
            const categoryId = this.activatedRoute.snapshot.params['id'];
            const keywords = this.activatedRoute.snapshot.params['keywords'];

            if (val instanceof NavigationEnd) {
                this.getLastComments();

                AppConfig.instance.getConfig(link => {
                    this.link_books = link['link_books'];
                });

                this.sub = this.activatedRoute.queryParams.subscribe(params => {
                    this.currentPage = +params['page'] || 1;
                });
                // this.currentPage = this.activatedRoute.snapshot.params['page'] || 1;

                this.params['page'] = this.currentPage || 1;

                if (categoryId) {
                    const catParams = categoryId.split('-');
                    this.params['category_id'] = catParams[catParams.length - 1];
                }

                if (keywords) {
                    this.params['search'] = keywords;
                }

                this.getBlogs();
            }

        }, error => {
            console.log(error);
        });
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
        this.navSub.unsubscribe();
    }

    getLastComments() {
        this.http.get(AppConfig.baseUrlApi + 'comments/api_comments?dir=DESC&limit=2').subscribe(response => {
            this.lastComments = response.content;
        }, error => {
            console.log(error);
        });
    }

    getBlogs() {
        const params = this.jsonToQueryString(this.params);
        this.blogLoaded = false;
        this.http.get(AppConfig.baseUrlApi + 'articles/api_articles' + params).subscribe(response => {
            this.blogList = response.content.articles === '' ? [] : response.content.articles;
            this.blogQuantity = response.content.quantity || 0;
            this.blogLoaded = true;
            this.blogLoaded = true;
        }, error => {
            console.log(error);
        });
    }

    jsonToQueryString(json) {
        return '?' +
            Object.keys(json).map(function (key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
    }

    pageChange(page) {
        this.router.navigate(['/blog'], {queryParams: {page: page}});
        this.currentPage = page;
        this.params['page'] = this.currentPage || 1;
        this.getBlogs();
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/blog/blog.component.ts